<template>
  <div v-show="isVisible">
    <div class="title">Описание услуги:</div>
    <div class="dop-info">
      <div>
        <div class="fieldset">
          <label class="fieldset-title">Время прибытия</label>
          <fieldset>
            <input type="text" class="time" placeholder="hh:mm" v-mask="'##:##'" v-model="time">
          </fieldset>
        </div>

      </div>
    </div>
    <div class="title">Адреса:</div>
    <div class="address-section">
      <draggable v-model="petrolServiceAddresses">
        <Address v-for="(address, i) in petrolServiceAddresses"
                 :key="'petrol-address-' + i"
                 :order="i"
                 :clientAddresses="clientAddresses"
                 :isForPetrolService="true"
                 :editable="!editProhibited"
        ></Address>
      </draggable>
      <div class="fieldset">
        <div class="add-address"><span class="icon" @click="addAddress">+</span><span
          @click="addAddress">Добавить адрес</span></div>
      </div>
      <div class="fieldset distance">
        <label class="fieldset-title">Расстояние</label>
        <fieldset><input type="number" v-model="manualDistance"></fieldset>
        <div class="distance-auto"><span>~</span> {{autoDistance}} <span class="km">км</span></div>
      </div>
    </div>
    <div class="buttons">
      <button type="button" class="save-button" @click="saveChanges">Сохранить</button>
    </div>
  </div>
</template>
<script>
    import draggable from 'vuedraggable'
    import Address from '@/views/Address.vue'
    import utils from '@/utils'
    import Timepicker from 'vue2-timepicker'
    import api from '@/api'
    import {mask} from 'vue-the-mask'

    export default {
  name: 'PetrolService',

  components: {
    Address,
    draggable,
    Timepicker
  },

  directives: { mask },

  props: ['isVisible', 'index', 'isNew', 'addressesFromOrder', 'clientAddresses', 'count', 'autoDistanceFromOrder', 'manualDistanceFromOrder', 'orderDateTime', 'orderStatus'],

  data () {
    return {
      newPetrolService: {
        type: 'OrderToPetrol',
        pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToPetrol',
        category: null,
        date: 0
      },

      petrolService: {
        category: null,
        date: 0
      },

      petrolCategories: [],
      manualDistanceVal: null
    }
  },

  computed: {
    currentService: {
      get () {
        return this.isNew
          ? this.newPetrolService
          : this.petrolService
      },

      set (service) {
        if (this.isNew) {
          this.newPetrolService = service
        } else {
          this.petrolService = service
        }
      }
    },

    petrolServiceAddresses: {
      get () {
        return this.$store.getters.addressesForPetrolService
      },

      set (addresses) {
        this.$store.dispatch('updateAddressesForPetrolService', addresses)
      }
    },

    time: {
      get () {
        return utils.getFormattedTimeStringFromLongWithoutTimezone(this.currentService.date)
      },

      set (value) {
        if (value.length == 5) {
          let date = new Date(this.currentService.date)
          date.setHours(0, 0, 0, 0)
          this.currentService.date = new Date(date.getTime() + utils.getLongFromFormattedTimeString(value)).getTime()
        }
      }
    },

    autoDistance: {
      get () {
        return this.$store.state.distanceForPetrolService
      }
    },

    manualDistance: {
      get () {
        return this.manualDistanceVal
      },
      set (manualDistance) {
        if (manualDistance !== '') {
          this.manualDistanceVal = manualDistance
        } else {
          this.manualDistanceVal = manualDistance
        }
      }
    },

    distance () {
      if (this.manualDistance !== '' && this.manualDistance != null) {
        return this.manualDistance
      } else {
        return this.autoDistance
      }
    },

    editProhibited () {
      return utils.checkRole(this.$store.getters.roleCode, ['ROLE_HR'])
          || (this.orderStatus == 5 && !utils.checkRole(this.$store.getters.roleCode, ['ROLE_BOOKER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']));
    }
  },

  watch: {
    isVisible (val) {
      if (val) {
        if (!this.isNew) {
          this.petrolService = Object.assign({}, this.$store.getters.groupedServices[this.index][0])
          this.manualDistanceVal = this.petrolService.distance
          this.petrolServiceAddresses = this.petrolService.addresses
        } else {
          this.newPetrolService = {
            type: 'OrderToPetrol',
            pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToPetrol',
            date: this.orderDateTime,
            category: this.petrolCategories[0]
          }

          this.manualDistanceVal = this.manualDistanceFromOrder
          this.petrolServiceAddresses = this.addressesFromOrder
            .filter(address => address.lat != null && address.lng != null)
            .map(address => Object.assign({}, address))
        }
      }
    }
  },

  mounted () {
    this.$store.commit('setDistanceForPetrolService', 0)
    api
      .getPetrolCategories()
      .then(petrolCategories => {
        if (petrolCategories) {
          this.petrolCategories = []
          this.petrolCategories = petrolCategories
        }
      })
  },

  methods: {
    saveChanges () {
      let promise
      if (this.isNew) {
        promise = this.addNewService()
      } else {
        promise = this.updateService()
      }
      this.$store.commit('addNewGroupedServicesPromise', promise)
      this.$emit('close-window', false)
    },

    updateService () {
      // при коммите в store index из property является undefined
      let index = this.index
      let count = this.count

      let addresses = this.petrolServiceAddresses.map((item, i) => {
        item.orderNum = i
        return item
      })

      let serviceData = {
        distance: this.manualDistanceVal,
        addresses: addresses,
        category: this.petrolService.category,
        date: this.petrolService.date
      }

      return new Promise(resolve => {
        utils.spotRegionAndDistrictByAddresses(this.petrolServiceAddresses, this.$store.getters.regions, this.$store.getters.districts)
          .then(regionDistrictData => {
            Object.assign(serviceData, regionDistrictData)

            this.$store.dispatch('updateGroupedServiceByIndex', {
              index: index,
              count: count,
              serviceData: serviceData
            }).then(() => resolve())
          })
      })
    },

    addNewService () {
      if (this.$store.getters.groupedServices.filter(gs => gs[0].type === 'OrderToPetrol').length > 0) {
        alert('Услуга ГСМ уже добавлена')
        return
      }

      this.newPetrolService.addresses = this.petrolServiceAddresses.map((item, i) => {
        item.id = 0
        item.orderNum = i
        return item
      })
      this.newPetrolService.distance = this.distance

      return new Promise(resolve => {
        utils.spotRegionAndDistrictByAddresses(this.newPetrolService.addresses, this.$store.getters.regions, this.$store.getters.districts)
          .then(regionDistrictData => {
            Object.assign(this.newPetrolService, regionDistrictData)

            let groupedService = []
            for (let i = 0; i < this.count; i++) { groupedService.push(Object.assign({}, this.newPetrolService)) }

            this.$store.dispatch('addNewGroupedService', groupedService).then(() => resolve())
          })
      })
    },

    addAddress () {
      let newAddress = utils.getDefaultAddress()
      let addresses = this.petrolServiceAddresses.slice(0)
      addresses.push(newAddress)
      this.petrolServiceAddresses = addresses
    }
  }
}
</script>
